export const LINKS = {
    dashboard: "/dashboard",
    mothers: "/mothers",
    drivers: "/drivers",
    admin: "/admin",
    editMother: "/edit-mother",
    login: "/login",
};
